import apiClient from './apiClient';

export const fastDomainCheckApi = (data) => {
  return apiClient.post('/partners/almata-partners/fast-domain-check', data);
};

export const getScansApi = (params) => {
  return apiClient.get('/partners/almata-partners/scans/list', { params });
};

export const getOemScansApi = (params) => {
  return apiClient.get('/partners/oem-partners/scan/list', { params });
};